module.exports = __webpack_public_path__ + "assets/eed00dd669e2c0af28cb56cf47695c26.mp3";